import { createFetcherReducer } from '../utils';
import { LOADING_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS_FAILED } from '../../actions/types';

export default createFetcherReducer(
  LOADING_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS, RECEIVED_RECOMMENDATIONS_FAILED,
);
